export default "__VITE_ASSET__845mNz7t__"